import { createServerFn } from "@tanstack/react-start";
import lodash from "lodash";

import { BOARDS_KEY_MAPPER_ENUM } from "@onesolution/constants";
import { authMiddleware, mondayBoards } from "@onesolution/middlewares";
import { mondayClient } from "@onesolution/monday/monday";
import z from "zod";
import { wrapWithUseQuery } from "..";

const getStatusChoicesParamsSchema = z.object({
	boardId: z.nativeEnum(BOARDS_KEY_MAPPER_ENUM),
	columnId: z.string(),
});

export type StatusChoices = Array<{ name: string; key: string }>;

const handler = createServerFn()
	.middleware([authMiddleware, mondayBoards])
	.validator(getStatusChoicesParamsSchema)
	.handler(async ({ context, data }) => {
		if (lodash.isNil(context.boards)) throw new Error("Boards are empty");
		const settings = await mondayClient.query.statusChoices({
			boardId: context.boards[data.boardId as BOARDS_KEY_MAPPER_ENUM],
			columnId: data.columnId,
		});

		if (!settings) return [];
		const parsed = JSON.parse(settings);
		if (Array.isArray(parsed.labels))
			return parsed.labels.map(({ name }: { id: number; name: string }) => ({
				key: name,
				name,
			})) as StatusChoices;

		return Object.entries(parsed.labels)
			.filter(([_, name]) => name)
			.map(([index, name]) => ({
				name,
				key: parsed.labels_colors[index]?.color,
			})) as StatusChoices;
	});

export const getStatusChoicesFromServer = wrapWithUseQuery(
	"statusChoices",
	handler,
);
